import { render } from "./Video.vue?vue&type=template&id=41107fac&scoped=true"
import script from "./Video.vue?vue&type=script&lang=ts"
export * from "./Video.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-41107fac"

export default script
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
